import React from "react";

import FooterSections from "./FooterSections";
import LegalLinks from "./LegalLinks";

const Footer = () => (
  <footer aria-labelledby="footerHeading">
    <div id="footerHeading" className="sr-only">
      Footer
    </div>
    <div className="lg:px-10 3xl:px-0 max-w-screen-2xl mx-auto">
      <hr className="border-t border-dove" />
      <div className="pb-6 lg:py-12 lg:px-4 grid grid-cols-2 lg:grid-cols-4">
        <FooterSections />
        <hr className="col-span-2 border-t border-dove lg:hidden" />
        <LegalLinks />
      </div>
    </div>
  </footer>
);

export default React.memo(Footer);
